export class ResizeHelper{
	private  timeOutId:number;
	private oldWith:number;

	public constructor(private resizeFinished: ()=> void){
		this.oldWith = window.innerWidth;
		this.resizeFinished = resizeFinished;
		window.addEventListener('resize',() => this.onResize(), true);
	}

	private onResize(){
     	clearTimeout(this.timeOutId);
    	// @ts-ignore
		this.timeOutId = setTimeout(() => this.finished(), 500);
	}

	private finished(){
		if(this.oldWith !== window.innerWidth){
			this.oldWith = window.innerWidth;
			this.resizeFinished();
		}
	}
}